import React, { ChangeEvent, Component, createRef, KeyboardEvent as ReactKeyboardEvent } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, InputAdornment, SxProps, TextField, Theme } from '@mui/material';

import { getAppMonitor } from '../../../../monitor';

interface Props {
  message: string;
  sx?: SxProps<Theme>;

  disabled?: boolean;

  value: string;
  active: boolean;
  onChange: (newValue: string) => void;
}

const SEARCH_COMPONENTS_PANEL_INPUT_ID = 'SEARCH_COMPONENTS_PANEL_INPUT_ID';
export const getComponentSearchInput = () => document.getElementById(SEARCH_COMPONENTS_PANEL_INPUT_ID);

class ComponentSearchField extends Component<Props> {
  inputRef = createRef<HTMLInputElement>();

  onChange = (event: ChangeEvent<HTMLInputElement>) => {
    // one count per search started (empty -> non-empty), not per keystroke. Known
    // undercount: select-all-and-retype never passes through empty and is not counted.
    if (!this.props.value && event.target.value) {
      getAppMonitor().recordInteraction('Component search started');
    }

    this.props.onChange(event.target.value);
  };

  onInputKeyDown = (event: ReactKeyboardEvent<HTMLDivElement>) => {
    if (event.nativeEvent.code === 'Escape') {
      event.stopPropagation();
      this.resetQuery();
    }
  };

  resetQuery = () => {
    this.props.onChange('');
  };

  render() {
    return (
      <TextField
        id={SEARCH_COMPONENTS_PANEL_INPUT_ID}
        fullWidth
        size="small"
        variant="filled"
        disabled={this.props.disabled}
        inputRef={this.inputRef}
        value={this.props.value}
        onKeyDown={this.onInputKeyDown}
        onChange={this.onChange}
        label={this.props.message}
        slotProps={{
          input: {
            endAdornment: this.props.active ? (
              <InputAdornment position="end">
                <IconButton onClick={this.resetQuery}>
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            ) : (
              <InputAdornment position="end">
                <SearchIcon sx={this.props.disabled ? { color: (theme) => theme.palette.text.disabled } : undefined} />
              </InputAdornment>
            ),
          },
        }}
        sx={this.props.sx}
      />
    );
  }
}

export default ComponentSearchField;
